export default "__VITE_ASSET__C_Dy2A82__"